import React from "react";
import { Segmented } from "antd";
import { MobileOutlined, TabletOutlined, DesktopOutlined, } from '@ant-design/icons';

export default function MobileSelector(props) {

    const { onChange = () => { }, setView = () => {} } = props;

    return (
        <div style={{ "margin": "0px -25px", "marginTop": "-15px" }}>
            <div className="shim" /><div className="shim" />
            <div style={{ "margin": "0px 20px" }}>
                <Segmented
                    onChange={(e) => {
                        setView(e);
                        if(e === "desktop"){
                            onChange(false)
                        } else {
                            onChange(true);
                        }
                    }}
                    block
                    size="small"
                    options={[
                        { label: <small><DesktopOutlined style={{ "opacity": ".5" }} /> Desktop</small>, value: "desktop" },
                        { label: <small><MobileOutlined style={{ "opacity": ".5" }} /> Mobile</small>, value: "phone" },
                    ]}
                />
            </div>
            <div className="shim" />
        </div>
    )
}